<template>
  <v-expansion-panel>
    <v-expansion-panel-header class="title">
      {{ slab.name }} - PP Sharing: {{ ppSharing }}
    </v-expansion-panel-header>
    <v-expansion-panel-content>
      <v-container fluid>
        <v-row>
          <v-col v-if="forGroup">
            <date-picker
              customLabel="Indicative Date"
              @onDateSelected="onIndicativePriceDateChange"
              :gt-date-string="indicativePriceDate"
              :outlined="outlinedInputs"
            ></date-picker>
          </v-col>
          <v-col>
            <v-text-field
              label="Pax From:"
              v-model="paxFrom"
              type="number"
              :outlined="outlinedInputs"
              min="1"
            ></v-text-field>
          </v-col>
          <v-col>
            <v-text-field
              label="Pax To:"
              v-model="paxTo"
              type="number"
              :outlined="outlinedInputs"
              min="1"
            ></v-text-field>
          </v-col>
          <v-col>
            <v-text-field
              v-if="false"
              label="FOC:"
              v-model="foc"
              type="number"
              :outlined="outlinedInputs"
              min="0"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-expansion-panel class="elevation-2">
              <v-expansion-panel-header>
                Services List
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-data-table
                  :items="items"
                  :headers="headers"
                  :expanded.sync="expanded"
                  class="ts-items-table"
                  :items-per-page="-1"
                >
                  <template v-slot:item.serviceName="{ item }">
                    <span>
                      {{ item.serviceName }}
                      <v-btn
                        text
                        small
                        icon
                        v-if="item.extras && item.extras.length > 0"
                        @click="expandExtras(item)"
                      >
                        <v-icon color="yellow darken-2">mdi-star</v-icon>
                      </v-btn>
                    </span>
                  </template>
                  <template v-slot:item.supplierName="{ item }">
                    <supplier-label
                      v-model="item.supplierName"
                      :supplier-type="item.serviceTypeName"
                    ></supplier-label>
                  </template>

                  <template v-slot:item.supplierComp="{ item }">
                    <v-text-field
                      type="number"
                      single-line
                      v-model="item.supplierComp"
                      min="0"
                      class="pt-1 ma-0 short-input"
                    ></v-text-field>
                  </template>
                  <template v-slot:item.passComp="{ item }">
                    <v-text-field
                      type="number"
                      single-line
                      v-model="item.passComp"
                      @input="onSlabItemPassCompChange(item)"
                      class="pt-1 ma-0 short-input"
                    ></v-text-field>
                  </template>
                  <template v-slot:item.foc="{ item }">
                    <v-text-field
                      type="number"
                      single-line
                      v-model="item.foc"
                      @input="onSlabItemFocChange(item)"
                      min="0"
                      class="pt-1 ma-0 short-input"
                    ></v-text-field>
                  </template>
                  <template v-slot:expanded-item="{ headers, item }">
                    <td :colspan="headers.length" class="pa-0">
                      <table>
                        <tr v-for="extra in item.extras" :key="extra.extraId">
                          <td v-for="header in headers" :key="header.name">
                            <template v-if="header.name == 'serviceName'">
                              <v-icon color="yellow darken-2" small
                                >mdi-star</v-icon
                              >
                              {{ extra.name }}
                            </template>
                            <template v-else-if="header.name == 'supplierName'">
                              <supplier-label
                                v-model="item.supplierName"
                                :supplier-type="item.serviceTypeName"
                              ></supplier-label>
                            </template>
                            <template
                              v-else-if="header.name == 'adults'"
                            ></template>
                            <template
                              v-else-if="header.name == 'children'"
                            ></template>
                            <template v-else-if="header.name == 'qty'">
                              <v-text-field
                                type="number"
                                v-model="extra.qty"
                                @input="onSlabItemExtraChange(item, extra)"
                                min="0"
                                class="pt-1 ma-0 short-input"
                              ></v-text-field>
                            </template>
                            <template v-else-if="header.name == 'supplierComp'">
                              <v-text-field
                                type="number"
                                v-model="extra.supplierComp"
                                @input="onSlabItemExtraChange(item, extra)"
                                min="0"
                                class="pt-1 ma-0 short-input"
                              ></v-text-field>
                            </template>
                            <template v-else-if="header.name == 'passComp'">
                              <v-text-field
                                type="number"
                                v-model="extra.passComp"
                                @input="onSlabItemExtraChange(item, extra)"
                                min="0"
                                class="pt-1 ma-0 short-input"
                              ></v-text-field>
                            </template>
                            <template v-else-if="header.name == 'foc'">
                              <v-text-field
                                type="number"
                                v-model="extra.foc"
                                @input="onSlabItemExtraChange(item, extra)"
                                min="0"
                                class="pt-1 ma-0 short-input"
                              ></v-text-field>
                            </template>
                            <template v-else>{{
                              extra[header.value]
                            }}</template>
                          </td>
                        </tr>
                      </table>
                    </td>
                  </template>
                </v-data-table>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-col>
        </v-row>
        <v-row v-if="forGroup">
          <v-col>
            <h5>Accommodation:</h5>
            <v-container>
              <v-card outlined>
                <v-data-table
                  :headers="accommodationsHeaders"
                  :items="accommodations"
                  :items-per-page="-1"
                  hide-default-footer
                >
                </v-data-table>
              </v-card>
            </v-container>
            <h5>Other Services:</h5>
            <v-container>
              <v-card outlined>
                <v-data-table
                  :headers="otherHeaders"
                  :items="otherServices"
                  :items-per-page="-1"
                  hide-default-footer
                >
                  <template v-slot:item.pp="{ item }">
                    <v-tooltip right max-width="300">
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn icon v-bind="attrs" v-on="on">
                          <v-icon color="grey lighten-1"
                            >mdi-information</v-icon
                          >
                        </v-btn>
                      </template>
                      <v-data-table
                        :headers="otherBreakdownHeaders"
                        :items="item.breakdown"
                        :items-per-page="-1"
                        hide-default-footer
                      >
                        <template v-slot:item.pp="{ item }">{{
                          item.pp.toFixed(2)
                        }}</template></v-data-table
                      >
                    </v-tooltip>
                    {{ item.pp.toFixed(2) }}
                  </template>
                </v-data-table>
                <v-row justify="center">
                  <span>Total: {{ totalOtherServices }}</span>
                </v-row>
              </v-card>
            </v-container>
            <h5>Charges:</h5>
            <v-container>
              <v-card outlined>
                <v-data-table
                  :headers="chargesHeaders"
                  :items="charges"
                  :items-per-page="-1"
                  hide-default-footer
                >
                  <template v-slot:item.adjustment="{ item }">
                    <v-text-field
                      type="number"
                      v-model="chargesData[item.occupancy].adjustment"
                      min="0"
                      class="pt-1 ma-0 short-input"
                    ></v-text-field>
                  </template>
                  <template v-slot:item.foc="{ item }">
                    <v-text-field
                      type="number"
                      v-model="chargesData[item.occupancy].foc"
                      min="0"
                      class="pt-1 ma-0 short-input"
                    ></v-text-field>
                  </template>
                  <template v-slot:item.pp="{ item }">
                    {{ Number(item.pp).toFixed(2) }}
                  </template>
                  <template v-slot:item.total="{ item }">
                    {{ Number(item.total).toFixed(2) }}
                  </template>
                </v-data-table>
              </v-card>
            </v-container>
          </v-col>

          <v-col>
            <v-textarea
              v-model="notes"
              label="Notes"
              :outlined="outlinedInputs"
              @change="dispatchChange"
              rows="8"
            ></v-textarea>
          </v-col>
        </v-row>
        <v-row v-else>
          <v-col>
            <v-textarea
              v-model="notes"
              label="Notes"
              :outlined="outlinedInputs"
              @change="dispatchChange"
            ></v-textarea>
          </v-col>
        </v-row>
        <v-row justify="center">
          <v-btn text color="secondary" @click="recalculate" :loading="loading"
            >Recalculate</v-btn
          >
          <v-btn color="warning" text @click="onRemove">Remove</v-btn>
        </v-row>

        <code v-if="debug"> {{ services }}</code>
      </v-container>
    </v-expansion-panel-content>
  </v-expansion-panel>
</template>

<script>
import SupplierLabel from "../../shared/labels/SupplierLabel";
import { ITINERARY_RECALCULATE_MUTATION } from "../../../../constants/graphql";
import { sortBy } from "../../../../helpers/index";
import { accommodationBucket } from "./increments/helpers";
import DatePicker from "../../shared/DatePicker";

const moment = require("moment");
const randomize = require("randomatic");
export default {
  name: "template-slab",

  props: {
    slab: {
      type: Object,
      default: () => {},
    },
    services: {
      type: Array,
      default: () => [],
    },
    headers: {
      type: Array,
      default: () => [],
    },
    departureDate: {
      type: String,
      default: () => "",
    },
    department: {
      type: String,
      default: () => "FIT",
    },
    destination: {
      type: String,
      default: () => "",
    },
    duration: {
      type: Number,
      default: () => 0,
    },
    extraTypes: {
      type: Array,
      default: () => [],
    },
    forGroup: {
      type: Boolean,
      default: () => false,
    },
  },

  components: { SupplierLabel, DatePicker },

  data() {
    return {
      debug: false,
      paxFrom: this.slab && this.slab.paxFrom ? this.slab.paxFrom : 1,
      paxTo: 10,
      notes: "",
      slabItinerary: null,
      loading: false,
      slabItems: this.slab && this.slab.items ? [...this.slab.items] : [],
      foc: this.slab && this.slab.foc ? this.slab.foc : 0,
      expanded: [],
      chargesData: {
        1: { adjustment: 0, foc: 0 },
        2: { adjustment: 0, foc: 0 },
        3: { adjustment: 0, foc: 0 },
        4: { adjustment: 0, foc: 0 },
        5: { adjustment: 0, foc: 0 },
      },
      indicativePriceDate: this.departureDate
        ? this.departureDate
        : moment().format("YYYY-MMM-DD"),

      chargesHeaders: [
        {
          text: "Charges",
          value: "name",
          name: "name",
        },
        {
          text: "PP",
          value: "pp",
          name: "pp",
        },
        {
          text: "FOC",
          value: "foc",
          name: "foc",
        },
        {
          text: "Adjust",
          value: "adjustment",
          name: "adjustment",
        },
        {
          text: "Total",
          value: "total",
          name: "total",
        },
      ],
      accommodationsHeaders: [
        {
          text: "Room Type",
          value: "name",
          name: "name",
        },
        {
          text: "PP",
          value: "pp",
          name: "pp",
        },
        {
          text: "Total PP",
          value: "totalPP",
          name: "totalPP",
        },
      ],
      otherHeaders: [
        {
          text: "Service Name",
          value: "name",
          name: "name",
        },
        {
          text: "PP",
          value: "pp",
          name: "pp",
        },
      ],
      otherBreakdownHeaders: [
        {
          text: "Pax",
          value: "pax",
          name: "pax",
        },
        {
          text: "Qty",
          value: "qty",
          name: "qty",
        },
        {
          text: "PP",
          value: "pp",
          name: "pp",
        },
      ],
    };
  },

  computed: {
    charges() {
      return this.accommodations.map((a) => ({
        name: a.name,
        pp: a.pp + this.totalOtherServices,
        adjustment: this.chargesData[a.occupancy].adjustment,
        total:
          Number(a.pp) +
          Number(this.totalOtherServices) +
          ((Number(a.pp) + Number(this.totalOtherServices)) *
            Number(this.chargesData[a.occupancy].foc)) /
            (Number(this.paxFrom) - Number(this.chargesData[a.occupancy].foc)) +
          Number(this.chargesData[a.occupancy].adjustment),
        occupancy: a.occupancy,
      }));
    },
    totalOtherServices() {
      return this.otherServices.reduce((sum, item) => sum + Number(item.pp), 0);
    },
    totalFocValue() {
      return this.items.reduce((sum, item) => sum + Number(item.focValue), 0);
    },
    otherServices() {
      return this.items
        .filter((item) => item.serviceTypeName != "ACCOMMODATION")
        .map((item) => {
          const breakdown = [];
          for (let i = this.paxFrom; i <= this.paxTo; i++) {
            const qty = Math.ceil(i / Number(item.stdOccupancy));

            breakdown.push({
              pax: i,
              qty,
              pp: (qty * Number(item.ppPrice)) / i,
            });
          }
          return {
            name: `${item.supplierName} - ${item.serviceName}`,
            breakdown,
            pp: breakdown.sort(sortBy("pp"))[breakdown.length - 1]["pp"],
          };
        });
    },
    accommodations() {
      const roomTypes = {
        1: "Single",
        2: "Double/Twin",
        3: "Triple",
        4: "Quad",
        100: "Multi Bed",
        200: "Guide",
      };
      const byRoomType = this.items
        .filter((item) => item.serviceTypeName == "ACCOMMODATION")
        .reduce((h, item) => {
          const key = accommodationBucket(item.stdOccupancy, item.typeName);
          if (!h[key]) h[key] = [];
          h[key].push(item);
          return h;
        }, {});
      return Object.keys(byRoomType).reduce((rooms, occupancy) => {
        rooms.push({
          name: roomTypes[occupancy],
          occupancy,
          pp: byRoomType[occupancy].reduce(
            (sum, item) => sum + Number(item.ppPrice),
            0
          ),
          totalPP: byRoomType[occupancy].reduce(
            (sum, item) => sum + Number(item.total),
            0
          ),
        });

        return rooms;
      }, []);
    },
    pricingDate() {
      return this.forGroup ? this.indicativePriceDate : this.departureDate;
    },
    items() {
      return this.services.map((templateServiceItem) => {
        const slabItem = this.slabItems.find(
          (si) => si.templateItemUid == templateServiceItem.uid
        );
        // const adults = slabItem
        //   ? Number(slabItem.adults)
        //   : templateServiceItem.stdOccupancy;
        // const children = slabItem ? Number(slabItem.children) : 0;
        // const infants = slabItem ? Number(slabItem.infants) : 0;
        // const totalPax = adults + children + infants;

        // const qty =
        //   templateServiceItem.serviceType == "ACCOMMODATION"
        //     ? Math.ceil(
        //         parseInt(totalPax) / parseInt(templateServiceItem.stdOccupancy)
        //       )
        //     : templateServiceItem.maxOccupancy
        //     ? Math.ceil(
        //         parseInt(totalPax) / parseInt(templateServiceItem.maxOccupancy)
        //       )
        //     : 1;
        const adults =
          templateServiceItem.serviceType == "ACCOMMODATION"
            ? parseInt(templateServiceItem.stdOccupancy)
            : 1;
        const children = 0;
        const infants = 0;
        const qty = 1;

        //pricing info from adhoc itinerary
        let total = 0;
        let rateType = "";
        let ppPrice = 0;
        const passComp = slabItem ? slabItem.passComp : 0;
        const foc = slabItem ? Number(slabItem.foc) : 0;

        if (this.slabItinerary) {
          const slabItiItem = this.slabItinerary.items.edges.find(
            (item) => item.node.id == templateServiceItem.uid
          );
          if (slabItiItem) {
            total = Number(slabItiItem.node.totalPrice);
            rateType = slabItiItem.node.rateTypeCode;
            ppPrice = Number(total / (adults + children)).toFixed(2);
          }
        }
        const focValue = Number((foc - passComp) * ppPrice).toFixed(2);

        return {
          id: templateServiceItem.uid,
          serviceId: templateServiceItem.serviceId,
          supplierName: templateServiceItem.supplierName,
          serviceName: templateServiceItem.serviceName,
          serviceTypeName: templateServiceItem.serviceType,
          adults,
          children,
          infants,
          qty,
          ppPrice,
          total: total.toFixed(2),
          rateType,
          foc,
          focValue,
          supplierComp: slabItem ? slabItem.supplierComp : 0,
          passComp,
          duration: templateServiceItem.duration,
          day: templateServiceItem.day,
          stdOccupancy: templateServiceItem.stdOccupancy,
          pricing: templateServiceItem.customPricing
            ? {
                adultBuy: templateServiceItem.adultBuy,
                adultSell: templateServiceItem.adultSell,
                childBuy: templateServiceItem.childBuy,
                childSell: templateServiceItem.childSell,
                infantBuy: 0,
                infantSell: 0,
                itemBuy: templateServiceItem.itemBuy,
                itemSell: templateServiceItem.itemSell,
                currencyBuy: templateServiceItem.currencyBuy,
                currencySell: templateServiceItem.currencySell,
                rateTypeCode: templateServiceItem.rateTypeCode,
              }
            : undefined,
          extras: templateServiceItem.extras.map(
            this.extraToItem({
              adults,
              children,
              infants,
              id: templateServiceItem.uid,
            })
          ),
        };
      });
    },
    outlinedInputs() {
      return this.$store.getters.localSettings("outlinedInputs");
    },
    slabItineraryInput() {
      const it = {
        adults: this.paxFrom.toString(),
        children: "0",
        infants: "0",
        department: this.department,
        destinationId: this.destination,
        agentId: this.$store.getters.agentId,
        startDate: this.pricingDate,
        endDate: moment(this.pricingDate)
          .add(this.duration, "days")
          .toISOString(),
        participants: [{ name: "TBA", surname: "TBA" }],
        items: [
          ...this.items.map((item) => {
            const itemDay = Number(item.day) - 1;
            const itemStartDate = moment(this.pricingDate).add(itemDay, "days");
            const itemDuration =
              item.serviceTypeName == "ACCOMMODATION"
                ? Number(item.duration)
                : Number(item.duration) - 1;

            const itemEndDate = moment(itemStartDate).add(itemDuration, "days");

            return {
              id: item.id,
              serviceId: item.serviceId,
              startDate: itemStartDate,
              endDate: itemEndDate,
              adults: item.adults,
              children: item.children,
              infants: item.infants,
              qty: item.qty,
              pricing: item.pricing ? { ...item.pricing } : undefined,
              extras: item.extras.length
                ? item.extras.map((e) => {
                    const extraDay = Number(e.day) - 1;
                    const extraStartDate = moment(this.pricingDate).add(
                      extraDay,
                      "days"
                    );
                    const extraDuration =
                      item.serviceType == "ACCOMMODATION"
                        ? Number(e.duration) + 1
                        : Number(e.duration);
                    const extraEndDate = moment(extraStartDate).add(
                      extraDuration,
                      "days"
                    );
                    return {
                      id: e.extraId,
                      uid: e.extraId,
                      qty: e.qty,
                      startDate: extraStartDate,
                      endDate: extraEndDate,
                    };
                  })
                : undefined,
            };
          }),
        ],
      };
      return it;
    },
    ppSharing() {
      const servicesAndExtras = this.items.reduce(
        (a, item) => [...a, item, ...item.extras],
        []
      );
      const totalPP = servicesAndExtras.reduce(
        (t, item) => t + Number(item.ppPrice),
        0
      );
      const totalFocValue = servicesAndExtras.reduce(
        (t, item) => t + Number(item.focValue),
        0
      );
      return Number(
        totalPP + totalFocValue / (this.paxFrom - this.foc)
      ).toFixed(2);
    },
  },

  watch: {
    paxFrom(newPax) {
      //update only non accommodation services
      // const nonAccommodation = this.items
      //   .filter((item) => item.serviceTypeName != "ACCOMMODATION")
      //   .map((item) => item.id);

      // this.slabItems = [
      //   ...this.slabItems.map((si) => ({
      //     ...si,
      //     adults:
      //       nonAccommodation.indexOf(si.templateItemUid) > -1
      //         ? Number(this.paxFrom)
      //         : si.adults,
      //   })),
      // ];
      // this.recalculate();
      this.dispatchChange();
    },
    foc(newFoc) {
      this.slabItems = [
        ...this.slabItems.map((si) => ({ ...si, foc: Number(this.foc) })),
      ];
      //this.recalculate();
      this.dispatchChange();
    },
    departureDate(newDate) {
      this.recalculate();
    },
    services(newServices) {
      const newSlabItems = newServices.reduce((a, templateServiceItem) => {
        const existingSlabItem = this.slabItems.find(
          (si) => si.templateItemUid == templateServiceItem.uid
        );
        if (existingSlabItem) {
          a.push({ ...existingSlabItem });
        } else {
          //create new slabItem for new service
          const qty =
            templateServiceItem.serviceType == "ACCOMMODATION"
              ? Math.ceil(
                  parseInt(this.paxFrom) /
                    parseInt(templateServiceItem.stdOccupancy)
                )
              : 1;
          const adults =
            templateServiceItem.serviceType == "ACCOMMODATION"
              ? Number(this.paxFrom)
              : 1;
          const children = 0;
          const infants = 0;
          const foc = Number(this.foc);
          a.push({
            id: randomize("Aa0", 32),
            templateItemUid: templateServiceItem.uid,
            adults,
            children,
            infants,
            qty,
            supplierComp: 0,
            passComp: 0,
            foc,
          });
          if (templateServiceItem.extras) {
            for (const extra of templateServiceItem.extras) {
              const extraType = this.extraTypes.find(
                (e) => e.node.id == extra.extraId
              );
              let extraQty = 1;
              if (extraType) {
                if (extraType.node.isChildOnly) {
                  extraQty = children;
                } else if (extraType.node.isInfantOnly) {
                  extraQty = infants;
                } else {
                  extraQty = adults; // + item.children + item.infants;
                }
              }
              a.push({
                id: randomize("Aa0", 32),
                templateItemUid: `${templateServiceItem.uid}_${extra.extraId}`,
                adults: 0,
                children: 0,
                infants: 0,
                qty: extraQty,
                supplierComp: 0,
                passComp: 0,
                foc: 0,
              });
            }
          }
        }

        return a;
      }, []);
      this.slabItems = [...newSlabItems];
      this.dispatchChange();
    },
  },

  methods: {
    onIndicativePriceDateChange(payload) {
      this.indicativePriceDate = payload;
      this.recalculate();
    },
    extraToItem(item) {
      return (extra) => {
        // first find slab settings for extra
        const templateItemUid = `${item.id}_${extra.extraId}`;
        const slabItem = this.slabItems.find(
          (si) => si.templateItemUid == templateItemUid
        );
        let qty = 1;
        if (slabItem) {
          qty = slabItem.qty;
        } else {
          const extraType = this.extraTypes.find(
            (e) => e.node.id == extra.extraId
          );
          if (extraType) {
            if (extraType.node.isChildOnly) {
              qty = item.children;
            } else if (extraType.node.isInfantOnly) {
              qty = item.infants;
            } else {
              qty = item.adults; // + item.children + item.infants;
            }
          }
        }
        //pricing info from adhoc itinerary
        let total = 0;
        let rateType = "";
        let ppPrice = 0;
        const foc = slabItem ? Number(slabItem.foc) : 0;
        if (this.slabItinerary) {
          const slabItiItem = this.slabItinerary.items.edges.find(
            (i) => i.node.id == item.id
          );
          if (slabItiItem) {
            const slabItiItemExtra = slabItiItem.node.extras.find(
              (e) => e.uid == extra.extraId
            );
            if (slabItiItemExtra && qty != 0) {
              total = Number(slabItiItemExtra.totalSell);
              rateType = slabItiItemExtra.rateTypeCode;
              ppPrice = Number(total / qty).toFixed(2);
            }
          }
        }
        const focValue = Number(foc * ppPrice).toFixed(2);
        return {
          ...extra,
          adults: item.adults,
          children: item.children,
          infants: item.infants,
          qty,
          foc,
          focValue,
          ppPrice,
          rateType,
          total: total.toFixed(2),
          supplierComp: slabItem ? slabItem.supplierComp : 0,
          passComp: slabItem ? slabItem.passComp : 0,
        };
      };
    },
    onSlabItemChange(item) {
      const editedIndex = this.slabItems
        .map((si) => si.templateItemUid)
        .indexOf(item.id);
      if (editedIndex > -1) {
        Object.assign(this.slabItems[editedIndex], {
          adults: parseInt(item.adults),
          children: parseInt(item.children),
          infants: parseInt(item.infants),
          foc: parseInt(item.foc),
          passComp: parseInt(item.passComp),
        });
      }
      this.recalculate();
    },
    onSlabItemPassCompChange(item) {
      const editedIndex = this.slabItems
        .map((si) => si.templateItemUid)
        .indexOf(item.id);
      if (editedIndex > -1) {
        Object.assign(this.slabItems[editedIndex], {
          passComp: parseInt(item.passComp),
        });
      }
    },
    onSlabItemFocChange(item) {
      const editedIndex = this.slabItems
        .map((si) => si.templateItemUid)
        .indexOf(item.id);

      if (editedIndex > -1) {
        Object.assign(this.slabItems[editedIndex], {
          foc: parseInt(item.foc),
        });
      }
      this.foc = [...this.items].sort(sortBy("foc")).reverse()[0].foc;
    },
    async recalculate() {
      try {
        this.loading = true;
        const res = await this.$apollo.mutate({
          mutation: ITINERARY_RECALCULATE_MUTATION,
          variables: this.slabItineraryInput,
        });
        this.slabItinerary = { ...res.data.recalculateItinerary };

        this.loading = false;
      } catch (error) {
        console.error(error);
        this.loading = false;
      }
    },
    dispatchChange() {
      this.$emit("change", {
        id: this.slab.id,
        name: this.slab.name,
        paxFrom: Number(this.paxFrom),
        foc: Number(this.foc),
        description: this.notes,
        items: [...this.slabItems],
      });
    },
    expandExtras(item) {
      const isExpanded = this.expanded.find((i) => i.id == item.id);
      this.expanded = isExpanded
        ? [...this.expanded.filter((i) => i.id != item.id)]
        : [...this.expanded, item];
      //console.log("expanding row for: ", item);
    },
    onSlabItemExtraChange(item, extra) {
      const templateItemUid = `${item.id}_${extra.extraId}`;
      const editedIndex = this.slabItems
        .map((si) => si.templateItemUid)
        .indexOf(templateItemUid);
      //console.log("editing ", item, extra, templateItemUid, editedIndex);
      if (editedIndex > -1) {
        //console.log("editing ", editedIndex);
        Object.assign(this.slabItems[editedIndex], {
          qty: parseInt(extra.qty),
          foc: parseInt(extra.foc),
          supplierComp: parseInt(extra.supplierComp),
          passComp: parseInt(extra.passComp),
        });
        this.recalculate();
      }
    },
    onRemove() {
      this.$emit("remove", {
        id: this.slab.id,
        name: this.slab.name,
        paxFrom: Number(this.paxFrom),
        foc: Number(this.foc),
        description: this.notes,
        items: [...this.slabItems],
      });
    },
  },

  mounted() {
    this.recalculate();
  },
};
</script>

<style>
.ts-items-table tr td:not(:nth-child(2)) {
  width: 105px;
}
.ts-items-table tr td:first-child:not(:only-child) {
  width: 200px;
}
</style>



// WEBPACK FOOTER //
// src/components/gt/templates/builder/TemplateSlab.vue